import queryParamFactory from './query-param-factory';
export default function (app) {
	queryParamFactory(app);
	app.factory('QueryParamService', ['QueryParamFactory', function (QueryParamFactory) {
		return QueryParamFactory.getInstance();
	}]);
};
